'use strict';

var createSvgIcon$1 = require('../../../../_virtual/createSvgIcon.js_commonjs-exports.js');
var interopRequireDefault = require('../../../@babel/runtime/helpers/interopRequireDefault.js');
var _extends = require('../../../@babel/runtime/helpers/extends.js');
var React = require('react');
var index = require('../../../../_virtual/index.js_commonjs-proxy2.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _interopRequireDefault = interopRequireDefault;

Object.defineProperty(createSvgIcon$1.__exports, "__esModule", {
  value: true
});
createSvgIcon$1.__exports.default = createSvgIcon;

var _extends2 = _interopRequireDefault(_extends._extends_1);

var _react = _interopRequireDefault(React__default["default"]);

var _SvgIcon = _interopRequireDefault(index);

function createSvgIcon(path, displayName) {
  var Component = _react.default.memo(_react.default.forwardRef(function (props, ref) {
    return _react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
      ref: ref
    }, props), path);
  }));

  if (process.env.NODE_ENV !== 'production') {
    Component.displayName = "".concat(displayName, "Icon");
  }

  Component.muiName = _SvgIcon.default.muiName;
  return Component;
}
